import { Adresse } from './adresse.model';
import type { Logement } from './logement.model';

/** Aligné sur {@code fr.gavicyconseil.dto.BienImmobilierDto}. */
export class BienImmobilier {
  idBienDto?: string;
  titreDto?: string;
  adresseDto?: Adresse;
  prixDto?: number;
  fraisNotaireDto?: number;
  fraisAgenceDto?: number;
  fraisDossierDto?: number;
  fraisCautionDto?: number;
  dateAchatDto?: Date | string;
  dateVenteDto?: Date | string;
  typeHabitatDto?: string;
  regimeDto?: string;
  periodeDto?: string;
  anneeConstructionDto?: number;
  usageDto?: string;
  partiesCommunesDto?: string;
  equipementsCommDto?: string;
  zoneTendueDto?: boolean;
  evolutionMaxLoyerDto?: boolean;
  loyerPlafonemmentDto?: boolean;
  loyerReferenceDto?: number;
  loyerMajoreDto?: number;
  complementLoyerDto?: string;
  loueEnEntierDto?: boolean;
  visibleDto?: boolean;
  nbLogementDto?: number;
  logementsDto?: Logement[];
}

export function formatAdresse(bien: BienImmobilier): string {
  const adresse = bien.adresseDto;
  if (!adresse) {
    return '';
  }
  return [adresse.rueDto, adresse.codePostalDto, adresse.villeDto]
    .filter((part) => typeof part === 'string' && part.length > 0)
    .join(', ');
}

export function unitesLabel(count?: number): string {
  const n = count ?? 0;
  if (n === 0) {
    return 'Aucune unité';
  }
  if (n === 1) {
    return '1 logement';
  }
  return `${n} logements`;
}

export const TYPES_HABITAT = [
  'Maison individuelle',
  'Immeuble individuel',
  'Immeuble collectif',
] as const;

export const REGIMES_JURIDIQUES = [
  'Mono propriété',
  'Copropriété',
] as const;

export const PERIODES_CONSTRUCTION = [
  'Avant 1949',
  'De 1949 à 1974',
  'De 1975 à 1989',
  'De 1990 à 2005',
  'Depuis 2005',
] as const;

export const USAGES_BIEN = [
  'Usage d’habitation',
  'Usage professionnel',
  'Usage mixte professionnel et d’habitation',
] as const;
